/**
 * AI Usage: requests, tokens and the billed amount of the practice's OpenAI
 * calls (Ask Velora, clinical notes), per office or all offices, by month.
 * Calculate and display only. Everyone with `marketplace.view` (the owner
 * included) sees billed amounts; Computers2Go support also sees the OpenAI
 * cost and edits prices and the multiplier (the API decides and strips).
 */
import { defineManifest } from '@velora/contracts';
import { AI_USAGE_VIEW_PERMISSION } from '@velora/contracts/ai-usage';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'ai-usage',
    title: 'AI Usage',
    version: '0.1.0',
    owner: 'WP4-AI-USAGE',
    entitlementKey: null,
    permissions: [AI_USAGE_VIEW_PERMISSION],
    routes: [
      {
        id: 'usage',
        path: '/ai-usage',
        title: 'AI Usage',
        officeScope: 'location-or-all',
        permission: AI_USAGE_VIEW_PERMISSION,
        readsPhi: false,
      },
    ],
    nav: [
      {
        label: 'AI Usage',
        group: 'settings',
        routeId: 'usage',
        icon: 'sparkles',
        order: 80,
      },
    ],
    commands: [
      {
        id: 'ai-usage.open',
        title: 'Go to AI Usage',
        keywords: ['ai', 'openai', 'tokens', 'usage', 'ask velora', 'clinical notes', 'billing'],
        routeId: 'usage',
        permission: AI_USAGE_VIEW_PERMISSION,
      },
    ],
    sseEntityKeys: [],
    phiReadPoints: [],
  }),
  pages: {
    usage: () => import('./AiUsagePage.js'),
  },
});
